import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Text, useDisclosure, Flex } from '@chakra-ui/react'
import { FaArrowLeft } from 'react-icons/fa'
import { Button as InnovationButton } from '../../../components/Button'
import { GoAlert } from 'react-icons/go'

export function ModalDeletarArtigo({ onConfirm, isLoading }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  async function handleConfirm() {
    await onConfirm()
    onClose()
  }

  return (
    <>
      <InnovationButton size="sm" onClick={onOpen} isLoading={isLoading} bgColor="red.500">
        Deletar
      </InnovationButton>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent minH="415px">
          <ModalHeader textAlign="center" color="red.500" fontSize="43px">
            <Flex alignItems="center" gap={2} justifyContent="center">
              <GoAlert color="red.500" />
              Atenção!
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" justifyContent="center">
            <Text fontSize="27px" textAlign="center">
              Você está prestes a deletar o artigo. Deseja realmente prosseguir?
            </Text>
          </ModalBody>

          <ModalFooter
            w="full"
            position="sticky"
            bottom="0"
            zIndex="sticky"
            borderTop="1px solid"
            borderColor="blue.500"
            p="10px"
            bg="white"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDir="row"
            gap="20px"
          >
            <Flex cursor="pointer" alignItems="center" gap="2" onClick={onClose}>
              <FaArrowLeft color="#378BBF" />
              Voltar e cancelar
            </Flex>

            <InnovationButton isLoading={isLoading} onClick={handleConfirm}>
              Deletar
            </InnovationButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
